import warning from 'warning';
var warned = {};
export default (function (valid, message) {
    if (!valid && !warned[message]) {
        warning(false, message);
        warned[message] = true;
    }
});


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/_util/warning.js
// module id = null
// module chunks = 